import gql from 'graphql-tag';
import FieldsBookingComplete from "graphql/fields/FieldsBookingComplete";
import FieldsBookingInvitation from "graphql/fields/FieldsBookingInvitation";
import HelperGraphql from 'utils/helper-graphql'
import FieldsBookingInvitationLog from 'graphql/fields/FieldsBookingInvitationLog'

const fields = {
	'guid': 'String!',
	'booking_active': '[String]',
	'booking_status': '[String]',
	'with_inviter': 'String',
}

export default gql(`
	query employee_booking_invitation( ${ HelperGraphql.createFields( fields ) } ) {
		employee_booking_invitation( guid: $guid ) {
			${FieldsBookingInvitation}
			description
			
			employee {
				guid
				name
			}
			
			employees_invited( with_inviter: $with_inviter ) {
				responded
				accepted
				rejected
				
				employee {
					guid
					name
					email
				}
			}
			
			bookings( active: $booking_active, status: $booking_status ) {
				${FieldsBookingComplete}
				
				employee {
					guid
					name
					email
				}
			}
			
			logs( page: 1, items_per_page: 3 ) {
				${FieldsBookingInvitationLog}
			}
		}
	}
`);

